import React, { Component } from 'react';
import autobind from 'autobind-decorator';
import { FloatingLabelInput } from '@lyearn-team/frontend-components';
import PropTypes from 'prop-types';
import Radium from 'radium';
import debounce from 'lodash/debounce';

const kTextInputHeight = 60.0;
const kTextInputFontSize = 16.0;
const kButtonFontSize = 13.0;
const kMarginBig = 16.0;
const kMarginTop14 = 14.0;

@Radium
class TextResponse extends Component {
  constructor(props) {
    super(props);
    this.textRefCode = `${this.props.questionId}_${this.props.cardId}`;
  }

  static propTypes = {
    response: PropTypes.string,
    position: PropTypes.number
  };

  state = {
    submitButton: !this.props.response || this.props.response === '' ? 'hidden' : 'edit',
    textBoxValue: this.props.response,
    responseToBeSubmitted: null
  };

  static contextTypes = {
    checkForSubmit: PropTypes.func
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.cardId !== nextProps.cardId) {
      this.saveOneResponseDebounced && this.saveOneResponseDebounced.cancel();
      !this.props.actualSubmit && this.props.saveOneResponse(this.getResponse(), this.props.cardId);

      this.state.responseToBeSubmitted = null;
      this.textRefCode = `${nextProps.questionId}_${nextProps.cardId}`;
      this.state.submitButton = !nextProps.response || nextProps.response === '' ? 'hidden' : 'edit';
      this.state.textBoxValue = nextProps.response;
    }

    // console.log('test response:: ', this.props.response, nextProps.response);

    if (
      (!nextProps.isResponseEntered && nextProps.responseEditedFlag)
      || (this.props.response !== undefined
        && this.props.response !== nextProps.response
        && nextProps.response === '')
    ) {
      this.state.textBoxValue = nextProps.response;
    }
  }

  componentWillUnmount() {
    this.saveOneResponseDebounced && this.saveOneResponseDebounced.cancel();
    !this.props.actualSubmit && this.props.saveOneResponse(this.getResponse(), this.props.cardId);
  }

  getResponse = () => {
    let enteredResponse = null;
    if (this.props.deletingResponse) {
      enteredResponse = '';
    } else if (typeof this.state.textBoxValue === 'string') {
      enteredResponse = this.state.textBoxValue;
    } else {
      enteredResponse = this.props.response;
    }

    // console.log(this.props.questionObj);
    return {
      questionObj: this.props.questionObj,
      emptySubmittedResponse: this.emptySubmittedResponse,
      responseData: {
        questionId: this.props.questionId,
        response: enteredResponse,
        answerEvaluation: !enteredResponse || enteredResponse !== '' ? '' : 'NA',
        responseType: 'TEXT',
        deletingResponse: this.props.deletingResponse,
        isOptional:
          this.props.card.resource.type === 'survey'
            ? !this.props.questionObj.contributeToCompleteStatus
            : false
      },
      callBack: () => {
        // if (window.textCardContent[this.textRefCode]) window.textCardContent[this.textRefCode].data = null;
        this.props.responseEnterChange(true);
      }
    };
  };

  emptySubmittedResponse = () => {
    // if (window.textCardContent[this.textRefCode]) window.textCardContent[this.textRefCode].data = null;
    this.setState({ textBoxValue: null });
  };

  responseTextChanged = (immediateSave = false) => (e) => {
    const text = e.target.value;
    if (text !== this.props.response) {
      this.showDoneButton = true;
    } else {
      this.showDoneButton = false;
    }

    this.setState({ textBoxValue: text }, () => {
      if (immediateSave || text === '') {
        this.props.saveOneResponse(this.getResponse(), this.props.cardId);
      } else {
        this.saveOneResponseDebounced(this.getResponse(), this.props.cardId);
      }
    });

    this.setState({});
  };

  saveOneResponseDebounced = debounce((response, cardId) => {
    if (!this.props.actualSubmit) {
      this.props.saveOneResponse(response, cardId);
    }
  }, 2000);

  /* donePressed = () => {
    this.showDoneButton = false;
    this.props.responseEdited(false);
    this.props.saveOneResponse(this.getResponse(), this.props.cardId);
    this.setState({});
  } */

  @autobind
  cancelPressed() {
    this.setState({
      submitButton: 'edit'
    });
    this.props.responseEnterChange(true);
  }

  // ,this.props.showEditButton ? styles.smallButton : styles.bigButton
  renderSubmissionView() {
    const submissionView = this.props.actualSubmit ? (
      <div style={styles.submittedResponse}>
        <pre style={styles.preStyle}>{this.props.response}</pre>
      </div>
    ) : (
      <FloatingLabelInput
        ref="textInput"
        defaultValue={this.props.response}
        style={styles.textAreaMainContainer}
        inputStyle={styles.textAreaContainer}
        fullWidth={true}
        textareaStyle={styles.textArea}
        placeholder="Type your response here..."
        hintStyle={styles.inputText}
        onChange={this.responseTextChanged(false)}
        underlineShow={false}
        multiline={true}
        minRows={4}
        autoFocus={this.props.autoFocus}
      />
    );
    // onBlur = { this.responseTextChanged(true) }

    return submissionView;
  }

  render() {
    return (
      <div onKeyDown={event => event.stopPropagation()}>
        {this.renderSubmissionView()}
        {/* {this.showDoneButton ? <div onClick={this.donePressed} style={styles.doneButtonContainer}><div style={styles.doneButton}>Done</div></div> : null} */}
      </div>
    );
  }
}

const styles = {
  column: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'center'
  },
  alignRight: {
    position: 'relative',
    zIndex: '2'
  },
  submitButton: {
    marginTop: kMarginTop14,
    cursor: 'pointer',

    height: '44px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    background: '#0ABFF1',
    color: 'white',
    borderRadius: '2px'
  },
  bigButton: {
    width: '248px'
  },
  smallButton: {
    width: '148px',
    marginRight: '12px'
  },
  disableSubmitButton: {
    cursor: 'default',
    background: '#C8CFD6'
  },
  cancelButton: {
    width: '148px',
    height: '42px',
    marginTop: kMarginTop14,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    borderRadius: '2px',
    border: 'solid 1px #767e86',
    color: '#767e86',
    textTransform: 'uppercase',
    justifyContent: 'center',
    fontSize: '13px',
    lineHieght: '18px',
    fontWeight: '500'
  },
  textAreaMainContainer: {
    // maxHeight: '213px'
  },
  textAreaContainer: {
    border: '1px solid #DBE2E8',
    boxSizing: 'border-box',
    // height: '280px',
    overflow: 'auto'
    // maxHeight: '280px'
  },
  textArea: {
    margin: '0px',
    padding: '16px 20px',
    // color: 'rgba(0,0,0,0.26)',
    color: 'rgba(0,0,0,0.8)',
    letterSpacing: '0.11px'
    // height: '270px'
  },
  inputText: {
    top: '16px',
    left: '20px',
    right: '0px',
    border: '0px',
    bottom: '16px'
  },
  textInput: {},
  buttonText: {
    fontSize: kButtonFontSize,
    color: 'white',
    lineHeight: '18px',
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    letterSpacing: '1px',
    fontWeight: '500'
  },
  submittedResponse: {
    fontSize: '14px',
    fontFamily: 'ProximaNova',
    color: 'rgba(0,0,0,0.8)',
    letterSpacing: '0.1px',
    lineHeight: '19px',
    wordWrap: 'break-word'
  },
  cancelButtonText: {
    marginLeft: '4px',
    marginTop: '2px'
  },
  doneButton: {
    position: 'relative',
    padding: '9px 16px',
    // minWidth: '248px',
    textAlign: 'center',
    background: '#42c4e3',
    color: '#fff',
    cursor: 'pointer',
    // margin: '0px 10px',
    fontWeight: '500',
    fontSize: '14px',
    float: 'left',
    ':hover': {
      background: '#40ACC5'
    },
    ':active': {
      background: '#2C7587'
    }
  },
  doneButtonContainer: {
    textAlign: 'left',
    padding: '10px 0 0',
    overflow: 'hidden'
  },
  preStyle: {
    whiteSpace: 'pre-wrap',
    wordWrap: 'break-word',
    fontFamily: 'inherit',
    background: 'none'
  }
};

module.exports = TextResponse;
